import styled from 'styled-components';

import { device, typography } from '@/styles/helpers';

export const ScLocalePopup = styled.div`
  border-radius: 24px;
  background-color: ${({ theme }) => theme.whiteColor};
  padding: 32px;
  display: flex;
  flex-direction: column;
  gap: 32px;
  max-width: 480px;
  margin: auto;
  position: relative;
  align-items: center;
  color: ${({ theme }) => theme.blackColor};
  @media (${device.mobileS}) {
    padding-inline: 16px;
    margin: auto 8px;
    max-width: 100%;
  }

  & .btn-close {
    @media (${device.mobileS}) {
      top: 16px;
      right: 16px;
    }
  }

  & > .img-container {
    width: 80px;
    height: 80px;
    position: relative;
  }

  .flag-img {
    width: 24px;
    height: 24px;
    position: absolute;
    top: 6px;
    right: 9px;
    display: flex;
    align-items: center;
  }

  .emoji {
    position: absolute;
    left: 0;
    bottom: 0;
  }

  .message {
    position: absolute;
    top: 0;
    right: 0;
  }

  & .text-wrapper {
    text-align: center;

    & .title {
      ${typography['headline2']}
      text-transform: uppercase;
      margin-bottom: 16px;
      @media (${device.mobileS}) {
        ${typography['headline2mobile']}
      }
    }

    & .subtitle {
      ${typography['body1regular']}
    }
  }
`;
